// components/Toggle.tsx
interface ToggleProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    labelOn: string;
    labelOff: string;
}

const Toggle: React.FC<ToggleProps> = ({ 
    checked, 
    onChange, 
    labelOn, 
    labelOff

}) => (
    <label className="inline-flex items-center cursor-pointer">
        <input
            type="checkbox"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            className="sr-only"
        />
        <div className={`relative w-10 h-5 rounded-full transition-colors duration-200 ${checked ? 'bg-blue-500' : 'bg-gray-200'}`}>
            <div className={`absolute w-4 h-4 bg-white rounded-full top-0.5 transition-transform duration-200 ${checked ? 'translate-x-5' : 'translate-x-1'}`} />
        </div>
        <span className="ml-2 text-sm font-medium text-gray-700">
            {checked ? labelOn : labelOff}
        </span>
    </label>
);

export default Toggle;